import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿El producto es digital?',
    a: 'Sí. Todo el material es 100% digital en PDF.'
  }, {
    q: '¿Cómo recibo el acceso?',
    a: 'Lo recibís inmediatamente después de comprar.'
  }, {
    q: '¿Puedo verlo desde el celular?',
    a: 'Sí. Desde celular, tablet o computadora.'
  }, {
    q: '¿Es solo para mamás primerizas?',
    a: 'Principalmente sí, aunque muchas mamás también lo usan en embarazos posteriores.'
  }, {
    q: '¿Incluye todos los bonus?',
    a: 'Sí. Los 4 bonus están incluidos sin costo adicional.'
  }, {
    q: '¿Necesito conocimientos previos?',
    a: 'No. Está explicado de forma simple y clara.'
  }, {
    q: '¿Cuánto tiempo tengo acceso?',
    a: 'El acceso es de por vida.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. Tenés 7 días de garantía total.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 md:py-28 bg-cream" data-id="element-92">
      <div className="max-w-3xl mx-auto px-6" data-id="element-93">
        <div className="text-center mb-16" data-id="element-94">
          <span className="inline-block text-xs md:text-sm font-bold tracking-[0.3em] text-peach-dark uppercase mb-4" data-id="element-95">
            ❓ PREGUNTAS FRECUENTES
          </span>
          <h2 className="font-serif text-text-dark leading-[1.05] tracking-tight" style={{
          fontSize: 'clamp(2rem, 5vw, 4rem)'
        }} data-id="element-96">
            Resolvé tus dudas
          </h2>
        </div>

        <div className="space-y-4" data-id="element-97">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white rounded-2xl border border-peach-light/50 overflow-hidden shadow-sm" data-id="element-98">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-99">
                <span className="font-medium text-text-dark pr-4" data-id="element-100">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-peach transition-transform duration-300 shrink-0 ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-101" />
              </button>
              <AnimatePresence data-id="element-102">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-103">
                    <div className="px-6 pb-5 text-text-muted" data-id="element-104">{faq.a}</div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}